import React from 'react';
import Banner from '../../components/Banner';
import Navbar from '../../components/Navbar';
import ShareHolding from '../../components/Shareholdings/ShareHolding';

function Shareholding() {
    return (
        <div>
            <Banner />
            <Navbar />
            <ShareHolding />
        </div>
    )
}

export default Shareholding